export const initAssets = [
  'brand/anim/skeleton.json',
  'atlases/init-0.json',
]
export const splashAssets = [
  'animations/spine/fullscreen/skeleton.json',
  'brand/images/brand.png',
  'atlases/splash-0.json',
  'atlases/base-0.json',
]
export const assets = [
  'animations/spine/back/land/skeleton.json',
  'animations/spine/back/port/skeleton.json',
  'animations/spine/items/A/skeleton.json',
  'animations/spine/items/B/skeleton.json',
  'animations/spine/items/C/skeleton.json',
  'animations/spine/items/D/skeleton.json',
  'animations/spine/items/E/skeleton.json',
  'animations/spine/items/F/skeleton.json',
  'animations/spine/items/G/skeleton.json',
  'animations/spine/items/H/skeleton.json',
  'animations/spine/lines/skeleton.json',
  'animations/spine/win/skeleton.json',
  'animations/spine/x2/skeleton.json',
  'bitmap/bitmap.xml',
  'atlases/main-0.json',
]
export const particle = []
